var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM9 15A6 6 0 109 3a6 6 0 000 12zm-.75-3.75h1.5v1.5h-1.5v-1.5zm0-6h1.5v4.5h-1.5v-4.5z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/warning.svg";
export { SvgWarning as ReactComponent };